import { SvgIcon, SvgIconProps } from '@mui/material'

const Search = (props: SvgIconProps) => {
  return (
    <SvgIcon role="img" viewBox="0 0 24 24" {...props}>
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M1.25 10.5a9.25 9.25 0 1 1 18.5 0 9.25 9.25 0 0 1-18.5 0Zm9.25-7.75a7.75 7.75 0 1 0 0 15.5 7.75 7.75 0 0 0 0-15.5Z"
        fill="currentColor"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M16.081 16.08a.75.75 0 0 1 1.06 0l4.243 4.243a.75.75 0 1 1-1.06 1.06l-4.243-4.242a.75.75 0 0 1 0-1.06Z"
        fill="currentColor"
      />
    </SvgIcon>
  )
}

export default Search
